import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function PhotoLightbox({ photos, start, title, onClose }) {
  const [idx, setIdx] = useState(start);
  const open = start !== null;
  const cur = open ? photos[idx ?? start] : null;
  const step = (d) => setIdx((i) => ((i ?? start) + d + photos.length) % photos.length);
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { setIdx(null); onClose(); } }}>
      <DialogContent className="max-w-5xl w-[96vw] p-0 bg-black border-white/10 overflow-hidden" data-testid="photo-lightbox">
        <DialogTitle className="sr-only">{title}</DialogTitle>
        {cur && <img src={cur.src} alt={cur.label} className="w-full max-h-[80vh] object-contain bg-black" data-testid="photo-lightbox-image" />}
        <div className="on-navy flex items-center justify-between px-4 py-3 bg-[#0F1D3D] text-white">
          <span className="text-[0.62rem] tracking-[0.22em] uppercase" data-testid="photo-lightbox-label">{title} · {cur?.label}</span>
          {photos.length > 1 && (
            <span className="flex gap-2">
              <button className="p-1.5 hover:text-[#C6A55C]" onClick={() => step(-1)} aria-label="Previous photo" data-testid="photo-lightbox-prev"><ChevronLeft size={18} /></button>
              <button className="p-1.5 hover:text-[#C6A55C]" onClick={() => step(1)} aria-label="Next photo" data-testid="photo-lightbox-next"><ChevronRight size={18} /></button>
            </span>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
